module.exports = __webpack_public_path__ + "img/富源县人民医院.5dbd01eb.png";